enum MenuId {
  myProjects = 'my-projects',
  lists = 'lists',
  catalogChannel = 'catalog-channel',
  myChannels = 'my-channels',
  channel = 'channel',
  project = 'project',
  folder = 'folder',
}

export { MenuId };
